(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/drawer/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-italic.woff":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/fonts/opensans-italic.woff?dd1a3b9ead29a3aa266b8b8fd9f7e979";

/***/ }),

/***/ "./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-italic.woff2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/fonts/opensans-italic.woff2?6d38b18228e21d4bb7fcb4422f93bb1e";

/***/ }),

/***/ "./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-light.woff":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/fonts/opensans-light.woff?53a11096c58b9941fea19dc3240b40a1";

/***/ }),

/***/ "./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-light.woff2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/fonts/opensans-light.woff2?da64ceea3b91e1d2bc28f854e4fe7333";

/***/ }),

/***/ "./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-lightitalic.woff":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/fonts/opensans-lightitalic.woff?389d741999c3d28780ffb6a84db60d97";

/***/ }),

/***/ "./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-lightitalic.woff2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/fonts/opensans-lightitalic.woff2?707849a517d0f6ac7822c75704c01d45";

/***/ }),

/***/ "./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-regular.woff":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/fonts/opensans-regular.woff?15825b5abe584d929bf7ad673578f3fc";

/***/ }),

/***/ "./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-regular.woff2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/fonts/opensans-regular.woff2?b441fb16c543a6088f2068dbbf95ab50";

/***/ }),

/***/ "./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-semibold.woff":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/fonts/opensans-semibold.woff?0784673c3833b6fac0ec191960d18f51";

/***/ }),

/***/ "./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-semibold.woff2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/fonts/opensans-semibold.woff2?a70818381c46b888dab5766b5f1bf75e";

/***/ }),

/***/ "./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-semibolditalic.woff":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/fonts/opensans-semibolditalic.woff?67c268765a81f4032874a717f928d05f";

/***/ }),

/***/ "./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-semibolditalic.woff2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "/fonts/opensans-semibolditalic.woff2?42ccf600b00cb4504df72f8f3afa8f40";

/***/ }),

/***/ 7:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-italic.woff");
__webpack_require__("./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-italic.woff2");
__webpack_require__("./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-light.woff");
__webpack_require__("./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-light.woff2");
__webpack_require__("./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-lightitalic.woff");
__webpack_require__("./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-lightitalic.woff2");
__webpack_require__("./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-regular.woff");
__webpack_require__("./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-regular.woff2");
__webpack_require__("./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-semibold.woff");
__webpack_require__("./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-semibold.woff2");
__webpack_require__("./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-semibolditalic.woff");
module.exports = __webpack_require__("./node_modules/@pearson-components/elements-sdk/build/fonts/opensans-semibolditalic.woff2");


/***/ })

/******/ });
});


// WEBPACK FOOTER //
// fonts.drawer.js